import { UserEvent } from "../../editor/userEventHandlers";

const invalidEventErrorMessage = (event: UserEvent, lastVerifiedEventID: string | undefined) => {
  return `A dev error occurred: Please relay below details to the dev team. 
          Invalid Event: ${JSON.stringify(event)}, 
          Time: ${new Date().getTime()},
          LastVerifiedEvent: ${lastVerifiedEventID}`;
};

export { invalidEventErrorMessage };